module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold.woff
// module id = 277
// module chunks = 0